module.exports = __webpack_public_path__ + "img/at.9a602abf.svg";